import styled from 'foundations-theming/utils';
import { devices } from '../../styles/viewports.styles';
import { isCanvasTheme } from 'foundations-theming/utils';
export const StyledManageCookiesContainer = styled.div.withConfig({
  displayName: "ManageCookiesstyles__StyledManageCookiesContainer"
})(["font-size:17px !important;text-align:center;display:flex;justify-content:center;align-items:end;margin-top:40px;gap:10px;@media ", "{z-index:2147483647 !important;margin-top:0;display:flex;text-align:center;flex-direction:column;align-items:start;position:fixed;bottom:0;padding-bottom:30px;left:40px;}a{", ";}"], devices.desktop, props => isCanvasTheme(props.theme) && 'color: #0b8484 !important');
export const StyledSidePanelManageCookiesContainer = styled.div.withConfig({
  displayName: "ManageCookiesstyles__StyledSidePanelManageCookiesContainer"
})(["z-index:2147483647 !important;display:flex;flex-direction:column;align-items:start;gap:10px;", " @media ", "{margin-top:0;bottom:0;left:0;}a{color:", ";}"], props => props.isMobile && `
    position: fixed;
    top: 20px;
    padding-top: 0;
    right: 20px;
    align-items: end;
  `, devices.desktop, props => props.theme.color['text-core-default']);